import React from "react";

function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_2012_28220)">
        <path
          d="M13.5 1.5C13.5 0.670312 12.8297 0 12 0C11.1703 0 10.5 0.670312 10.5 1.5V12.8766L7.05938 9.43594C6.47344 8.85 5.52188 8.85 4.93594 9.43594C4.35 10.0219 4.35 10.9734 4.93594 11.5594L10.9359 17.5594C11.5219 18.1453 12.4734 18.1453 13.0594 17.5594L19.0594 11.5594C19.6453 10.9734 19.6453 10.0219 19.0594 9.43594C18.4734 8.85 17.5219 8.85 16.9359 9.43594L13.5 12.8766V1.5ZM3 16.5C1.34531 16.5 0 17.8453 0 19.5V21C0 22.6547 1.34531 24 3 24H21C22.6547 24 24 22.6547 24 21V19.5C24 17.8453 22.6547 16.5 21 16.5H16.2422L14.1188 18.6234C12.9469 19.7953 11.0484 19.7953 9.87656 18.6234L7.75781 16.5H3ZM20.25 19.125C20.5484 19.125 20.8345 19.2435 21.0455 19.4545C21.2565 19.6655 21.375 19.9516 21.375 20.25C21.375 20.5484 21.2565 20.8345 21.0455 21.0455C20.8345 21.2565 20.5484 21.375 20.25 21.375C19.9516 21.375 19.6655 21.2565 19.4545 21.0455C19.2435 20.8345 19.125 20.5484 19.125 20.25C19.125 19.9516 19.2435 19.6655 19.4545 19.4545C19.6655 19.2435 19.9516 19.125 20.25 19.125Z"
          fill="#0055A4"
        />
      </g>
      <defs>
        <clipPath id="clip0_2012_28220">
          <path d="M0 0H24V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DownloadIcon;
